export const workspaceEvents = new EventTarget();

export const emitWorkspaceChange = (index) => {
  workspaceEvents.dispatchEvent(
    new CustomEvent("workspaceChange", { detail: { index } })
  );
};